// api.js
// const API_BASE_URL = 'http://localhost:5000/api';

const API_BASE_URL = 'https://landnest.net:7000/api';

export const normalizeLookingFor = (value) => {
  if (!value) return null;
  return value.toLowerCase();
};

export const normalizePropertyType = (value) => {
  if (!value) return null;
  return value.toLowerCase();
};

export const getFilterOptionsNew = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/options/filters/new`);
    const data = await response.json();
    
    console.log('Filter options response:', data);
    
    if (!response.ok) throw new Error(data.error || 'Failed to fetch');
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return { 
      success: false, 
      typeOptions: [],
      propertyTypeOptions: [],
      priceRange: { min: 0, max: 5000000000 },
      totalProperties: 0
    };
  }
};

export const getMapPropertiesNew = async (filters) => {
  const params = new URLSearchParams();

  console.log('API Request Filters:', filters);

  if (filters.type && filters.type.length > 0) {
    const typeValue = Array.isArray(filters.type) 
      ? filters.type.map(t => normalizeLookingFor(t)).filter(Boolean).join(',')
      : normalizeLookingFor(filters.type);
    if (typeValue) params.append("type", typeValue);
  }
  
  // Subcategory filter (PLOT or LAND)
  if (filters.propertyType && filters.propertyType.length > 0) {
    const propertyTypeValue = Array.isArray(filters.propertyType)
      ? filters.propertyType.map(p => normalizePropertyType(p)).filter(Boolean).join(',')
      : normalizePropertyType(filters.propertyType);
    if (propertyTypeValue) params.append("propertyType", propertyTypeValue);
  }

  if (filters.bounds) {
    params.append('south', filters.bounds.south);
    params.append('north', filters.bounds.north);
    params.append('west', filters.bounds.west);
    params.append('east', filters.bounds.east);
  }
  
  if (filters.zoom) params.append('zoom', filters.zoom);
  if (filters.priceMin != null) params.append('priceMin', filters.priceMin);
  if (filters.priceMax != null) params.append('priceMax', filters.priceMax);
  if (filters.limit) params.append('limit', filters.limit);

  try {
    const response = await fetch(`${API_BASE_URL}/properties/map/new?${params.toString()}`);
    const data = await response.json();
    
    console.log('Map properties response:', data);
    
    if (!response.ok) throw new Error(data.error || "Failed to fetch");
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { success: false, properties: [], count: 0 };
  }
};

// Backward compatibility
export const getFilterOptions = getFilterOptionsNew;
export const getMapProperties = getMapPropertiesNew;